<script>import QRCode from "qrcode";
import { verify } from "otplib";
export let secret;
export let policy;
export let onChange;
let mfa = policy === "authenticator";
$:
  _mfa = mfa;
let showSecret = false;
let code = "";
let codeIsInvalid = false;
$:
  delimiter = secret.indexOf("#");
$:
  authenticatorSecret = secret.substring(0, delimiter);
$:
  authenticatorUri = secret.substring(delimiter + 1);
$:
  qrSvg = "";
$: {
  if (authenticatorUri && authenticatorUri.length > 0) {
    QRCode.toString(authenticatorUri, { type: "svg" }).then(
      (svg) => qrSvg = svg
    );
  }
}
const updateMfa = (enabled) => mfa = enabled;
$: {
  if (_mfa && !mfa) {
    showSecret = true;
  } else {
    showSecret = false;
    if (mfa != _mfa) {
      updateMfa(_mfa);
      policy = mfa ? "authenticator" : "password";
      if (onChange) {
        onChange(mfa ? "authenticator" : "password");
      }
    }
  }
}
const verifyCode = async () => {
  console.log(
    `verifyCode ${code != void 0 ? code : "undefined"} with secret length is ${authenticatorSecret ? authenticatorSecret.length : "undefined"}`
  );
  let isValid = code.length === 6 ? (await verify({ secret: authenticatorSecret, token: code })).valid : false;
  if (isValid) {
    mfa = true;
    showSecret = false;
    codeIsInvalid = false;
    policy = mfa ? "authenticator" : "password";
    if (onChange) {
      onChange(mfa ? "authenticator" : "password");
    }
  } else {
    codeIsInvalid = true;
  }
};
const handleEnterKey = async (ev) => {
  if (ev.key == "Enter") {
    ev.preventDefault();
    ev.stopPropagation();
    verifyCode();
  } else {
    codeIsInvalid = false;
  }
};
export const getPolicy = () => {
  return policy;
};
export const setPolicy = (_policy) => {
  policy = _policy;
  mfa = policy === "authenticator";
  _mfa = mfa;
  showSecret = false;
  codeIsInvalid = false;
};
export const setSecret = (_secret) => {
  delimiter = _secret.indexOf("#");
  authenticatorSecret = _secret.substring(0, delimiter);
  authenticatorUri = _secret.substring(delimiter + 1);
};
</script>

<div class="mfa-selector">
  <input id="mfaToggle" type="checkbox" bind:checked={_mfa} />
  {#if showSecret}
    {#if qrSvg && qrSvg.length > 0}
      <p class="qr">
        {@html qrSvg}
      </p>
    {:else}
      <p class="no-qr">QR-code not available</p>
    {/if}
    <p class="secret">{authenticatorSecret}</p>
    <p class="explain">
      Please configure your authenticator and enter a code to verify.
    </p>
    <p class="wrong-code {codeIsInvalid ? 'show' : ''}">Code is invalid.</p>
    <p class="code">
      <label for="mfa-code">Code</label><input
        id="mfa-code"
        type="text"
        bind:value={code}
        on:keypress={handleEnterKey}
      /><button class="btn" on:click={verifyCode}>Verify</button>
    </p>
  {/if}
</div>

<style>
  div.mfa-selector {
    font-family: "Roboto";
    font-size: 14px;
    line-height: 19px;
  }
  p.qr {
    width: 100%;
    text-align: center;
  }

  p.secret {
    text-align: center;
    overflow-wrap: break-word;
  }
  p.wrong-code {
    visibility: hidden;
    text-align: center;
  }
  p.wrong-code.show {
    visibility: visible;
  }
  p.code {
    text-align: center;
  }
  p.code label {
    white-space: normal;
    font-weight: bold;
    margin: 4px;
    display: inline-block;
  }
  p.code input {
    width: 10em;
  }
</style>
